import { createSlice } from '@reduxjs/toolkit';

const editPropDetailsPopup = createSlice({
  name: 'editPropDetailsPopup',
  initialState: {
    data: null,
  },
  reducers: {
    show: (state, { payload }) => {
      state.data = payload
    },
    close: (state) => {
      state.data = null;
    },
  },
});

export const editPropDetailsPopupActions = editPropDetailsPopup.actions;
export const editPropDetailsPopupSelector = (state) => state.editPropDetailsPopup;
export const editPropDetailsPopupReducer = editPropDetailsPopup.reducer;
export default editPropDetailsPopupReducer;

export const selectEditPropDetailsPopupData = (state) => state.editPropDetailsPopup.data